/* eslint-disable global-require, import/no-dynamic-require */
import createContainer from 'constate';
import { useEffect, useState } from 'react';
import { nameHOC } from './hocutils';
import { changeProductRoute } from './RouteHandler';

const changeVariant = (productData, setProductData) => (site, variantId, store, regionCode, force) => {
  const { currentVariant, id, slug, variants } = productData;
  if (!force && (variantId === currentVariant || !variants.some((v) => v.id === variantId))) {
    return;
  }
  const updatedProductData = JSON.parse(JSON.stringify(productData));
  updatedProductData.currentVariant = variantId;

  setProductData(updatedProductData);

  changeProductRoute({
    site,
    id,
    slug,
    variant: variantId,
    store,
    regionCode,
  });
};

const changeLinkedProductVariant = (productData, setProductData) => (productId, variantId) => {
  const updatedProductData = JSON.parse(JSON.stringify(productData));

  const { linkedProducts } = updatedProductData;
  if (!linkedProducts || !linkedProducts[productId]) {
    return;
  }
  updatedProductData.linkedProducts[productId].currentVariant = variantId;

  setProductData(updatedProductData);
};

function useProductContextHook({ data: initialProductData }) {
  const [productData, setProductData] = useState(initialProductData);
  useEffect(() => {
    setProductData(initialProductData);
  }, [initialProductData]);
  return {
    recommendedProducts: [],
    ...productData,
    changeVariant: changeVariant(productData, setProductData),
    changeLinkedProductVariant: changeLinkedProductVariant(productData, setProductData),
    setProductData,
  };
}

const [ProductContextProvider, useProductContext] = createContainer(useProductContextHook);

const withProduct = (WrappedComponent) => {
  const { getInitialProps } = WrappedComponent;
  const ComponentWithProductData = (props) => {
    const productDataWithState = useProductContext();
    return <WrappedComponent {...props} product={productDataWithState} />;
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithProductData.getInitialProps = getInitialProps;
  }
  ComponentWithProductData.originalName = nameHOC(WrappedComponent);
  ComponentWithProductData.displayName = nameHOC(WrappedComponent, 'WithProduct');
  return ComponentWithProductData;
};

export { withProduct, ProductContextProvider, useProductContext };
